import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";
import { useHistory } from "react-router-dom";

import BaseDataTable from "../../../components/modules/BaseDataTable";
import Select from "../../../components/elements/Select";
import classes from "./AdvertiserDetailsSection.module.scss";
import { AdvertiserType } from "../../../types/advertiserTypes";
import { SelectOptionType } from "../../../components/elements/Select/Select";
import { truncateText } from "../../../helpers/truncateText";

type AdvertiserBasicDetailsProps = {
  advertisers: AdvertiserType[];
  advertiser: AdvertiserType;
};

const ArchivedBadge = styled("span")(({ theme }: { theme: Theme }) => ({
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  padding: "2px 6px",
  borderRadius: 4,
  background: theme.palette.brand.gray100,
  color: theme.palette.brand.gray500,
  marginLeft: 8,
  verticalAlign: "middle",
}));

const ActiveBadge = styled("span")({
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  padding: "2px 6px",
  borderRadius: 4,
  background: "#e8f5e9",
  color: "#2e7d32",
});

const AdvertiserBasicDetails: FC<AdvertiserBasicDetailsProps> = ({ advertiser, advertisers }) => {
  const options: SelectOptionType[] = advertisers.map(({ name, brandgenAdvertiserId }) => ({
    label: name,
    value: brandgenAdvertiserId,
  }));

  const columns = [
    { key: "name", label: "Name", minWidth: 170 },
    { key: "status", label: "Status", minWidth: 120 },
    { key: "createdBy", label: "Created by", minWidth: 150 },
    { key: "domain", label: "Domain", minWidth: 150 },
    { key: "address", label: "Address", minWidth: 150 },
    { key: "phoneNumber", label: "Phone Number", minWidth: 150 },
  ] as const;

  const history = useHistory();

  const rows = [
    {
      id: advertiser.brandgenAdvertiserId,
      name: <Typography className={classes.dashboardLongTextInfo}>{advertiser.name}</Typography>,
      status: advertiser.archived ? <ArchivedBadge>Archived</ArchivedBadge> : <ActiveBadge>Active</ActiveBadge>,
      createdBy: advertiser.createdBy,
      domain: advertiser.domain ? (
        <a href={advertiser.domain} target="_blank" className={classes.dashboardLongTextInfo} rel="noopener noreferrer">
          {advertiser.domain}
        </a>
      ) : null,
      address: (
        <>
          <Typography className={classes.dashboardLongTextInfo}>{`Address 1: ${advertiser.address_1}.`}</Typography>
          {advertiser.address_2 ? (
            <Typography className={classes.dashboardLongTextInfo}>{`Address 2: ${advertiser.address_2}.`}</Typography>
          ) : null}
        </>
      ),
      phoneNumber: advertiser.phone ?? "None",
    },
  ];

  const handleChangeAdvertiserDetailToView = (e: any) => {
    const brandgenAdvertiserId = (e.target as HTMLSelectElement).value;
    history.replace({
      pathname: `/advertisers/${brandgenAdvertiserId}`,
      search: "",
    });
  };

  return (
    <div className={classes.advertiserBasicDetails}>
      <div className={classes.advertiserBasicDetailsHead}>
        <Tooltip title={advertiser.name}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h2">{truncateText(advertiser.name, 36)}</Typography>
            {advertiser.archived ? <ArchivedBadge>Archived</ArchivedBadge> : null}
          </span>
        </Tooltip>

        <div className={classes.selector}>
          <Select
            className={classes.select}
            label={null}
            options={options}
            value={advertiser.brandgenAdvertiserId}
            onChange={handleChangeAdvertiserDetailToView}
          />
        </div>
      </div>

      <div className={classes.dashboard}>
        <BaseDataTable columns={columns} rows={rows} />
      </div>
    </div>
  );
};

export default AdvertiserBasicDetails;
